import React, { useEffect } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Header from '../navigation/header';
import { Route, Routes } from 'react-router-dom';
import LoginPage from './auth/loginPage';
import PrivateRoute from '../navigation/privateRoute';
import TransformPage from './transform/transformPage';
import MappingPage from './mapping/mappingPage';
import FileOverviewPage from './files/fileOverviewPage';
import ReportsPage from './BI/reportsPage';
import { locale, loadMessages } from "devextreme/localization";
import nlMessages from "devextreme/localization/messages/nl.json";
import enMessages from "devextreme/localization/messages/en.json";
import frMessages from "devextreme/localization/messages/fr.json";
import RegistrationsPage from './Registrations/RegistrationsPage';

export default function IndexPage(props) {
    console.log('IndexPage')
    useEffect(() => {


    }, []);
     
    
    const classes = useStyles();
    let headerBar = <React.Fragment></React.Fragment>;
    if (props.user.loggedIn) {
        headerBar = <div className={classes.header}>
            <Header {...props}></Header>
        </div>;
    }

    return (
        <div className={classes.dashboard} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/bgr-logo.svg), linear-gradient(#EFEFEF,#FFFFFF)`, backgroundRepeat: "no-repeat", backgroundPosition: 'right bottom', backgroundSize: '40%,100%', position: "absolute", width: "100%", zIndex: "0" ,textAlign:"center"}}>
            {headerBar}
            <div className={classes.content}>
                <Routes>
                    <Route path="/login" element={<LoginPage {...props}/>} />   
                    <Route
                        path="/"
                        element={
                            <PrivateRoute {...props}>
                                <RegistrationsPage {...props} />
                            </PrivateRoute>
                        }
                    />
                     <Route
                        path="/reports"
                        element={
                            <PrivateRoute {...props}>
                                <ReportsPage {...props} />
                            </PrivateRoute>
                        }
                    />                      
                    <Route
                        path="/transform"
                        element={
                            <PrivateRoute {...props}>
                                <TransformPage {...props} />
                            </PrivateRoute>
                        }
                    />
                     <Route
                        path="/mappings"
                        element={
                            <PrivateRoute {...props}>
                                <MappingPage {...props} />
                            </PrivateRoute>
                        }
                    />  
                    <Route
                        path="/files"
                        element={
                            <PrivateRoute {...props}>
                                <FileOverviewPage {...props} />
                            </PrivateRoute>
                        }
                    />  
                </Routes>
            </div>
            <div className={classes.powered}>Powered by Flagstone</div>
        </div>
    )
}


const useStyles = makeStyles({
    dashboard: {
        display: "inline-block",
        width: "100%",
    },
    content: {
        height: '100%',
    },
    powered: {
        height: "20px",
        width: "150px",
        position: "absolute",
        bottom: "70px",
        right: "40px",
        overflow: "hidden",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#E8E8E8",
        zIndex: "-1"
      }
});